import { commentModels, Images } from '../../utils';

/**
 * Maps a comment mention's `onModel` (see `commentModels`) to the staff-app detail
 * route segment whose page exposes a "Comments" tab. Navigating there with
 * `state.activeTab: 'Comments'` makes `SimpleTabs` land directly on that tab.
 *
 * Entities that have no detail route are intentionally absent:
 *  - `appt` is opened via the `ScheduleDetails` modal (handled in `handleMarkAsRead`);
 *  - `claim` / `bill` / `txn` / `invoicetxn` / `paymentTransaction` have no routed
 *    Comments target, so a mention on them only marks the notification as read.
 */
export const commentModelRouteMap = {
    [commentModels.Funder]: 'fundingSource',
    [commentModels.Client]: 'client',
    [commentModels.Staff]: 'staff',
    [commentModels.Invoice]: 'invoice',
};

export const notificationTypesEnums = {
    CREDENTIALS_EXPIRATION: 'CREDENTIALS_EXPIRATION',
    LICENSE_EXPIRATION: 'LICENSE_EXPIRATION',
    SERVICE_ADD: 'SERVICE_ADD',
    SERVICE_DELETE: 'SERVICE_DELETE',
    APPT_GROUP_CREATE: 'APPT_GROUP_CREATE',
    APPT_CREATE: 'APPT_CREATE',
    APPT_UPDATE: 'APPT_UPDATE',
    APPT_CANCEL: 'APPT_CANCEL',
    APPT_LOCK: 'APPT_LOCK',
    APPT_UNLOCK: 'APPT_UNLOCK',
    APPT_RENDER: 'APPT_RENDER',
    APPT_UNRENDER: 'APPT_UNRENDER',
    APPT_ADD_NOTE_REQUEST: 'APPT_NOTE_REQUEST',
    APPT_UPDATE_NOTE_REQUEST: 'APPT_UPDATE_NOTE_REQUEST',
    APPT_ADD_NOTE_RESOLVED: 'APPT_ADD_NOTE_RESOLVED',
    INTAKE_FORM_COMPLETED: 'INTAKE_FORM_COMPLETED',
    REQUEST_NEW_LINK: 'REQUEST_NEW_LINK',
    APPT_SIGNATURE_REMIND: 'APPT_SIGNATURE_REMIND',
    COMMENT_MENTION: 'COMMENT_MENTION',
};

export const renderIcon = (type) => {
    if (type === notificationTypesEnums.CREDENTIALS_EXPIRATION || type === notificationTypesEnums.LICENSE_EXPIRATION) {
        return Images.danger;
    } else if (type === notificationTypesEnums.SERVICE_DELETE) {
        return Images.redTrash;
    } else if (type === notificationTypesEnums.SERVICE_ADD) {
        return Images.newServiceAdded;
    } else if (type === notificationTypesEnums.APPT_CREATE) {
        return Images.newApptCreated;
    } else if (type === notificationTypesEnums.APPT_UPDATE) {
        return Images.apptEdited;
    } else if (type === notificationTypesEnums.APPT_CANCEL) {
        return Images.apptCancelled;
    } else if (type === notificationTypesEnums.APPT_LOCK) {
        return Images.lock;
    } else if (type === notificationTypesEnums.APPT_UNLOCK) {
        return Images.unlock;
    } else if (type === notificationTypesEnums.APPT_RENDER) {
        return Images.apptComplete;
    } else if (type === notificationTypesEnums.INTAKE_FORM_COMPLETED || type === notificationTypesEnums.REQUEST_NEW_LINK) {
        return Images.infoGrayIcon;
    } else if (
        type === notificationTypesEnums.APPT_UNRENDER ||
        type === notificationTypesEnums.APPT_ADD_NOTE_REQUEST ||
        type === notificationTypesEnums.APPT_UPDATE_NOTE_REQUEST ||
        type === notificationTypesEnums.APPT_ADD_NOTE_RESOLVED ||
        type === notificationTypesEnums.APPT_SIGNATURE_REMIND
    ) {
        return Images.apptAlert;
    } else if (type === notificationTypesEnums.APPT_GROUP_CREATE) {
        return Images.newApptCreated;
    } else {
        return Images.newServiceAdded;
    }
};
